<template>
  <div class="message-back" style="overflow-x:hidden ">
    <NavHeader :status="{
        page:'message',
        produce:false,
        solution:false
      }">
    </NavHeader>

    <div class="message-body">
      <div class="account-line" style="margin-top: 0.3vw;width: 95%;margin-bottom: 1vh">
        <div style="display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: flex-end;  height: 8vh;min-height: 40px;align-items: center;width: 100%;">
          <div class="line-font">
            <div class="line-font-left" style="background-color: rgb(255, 212, 80)"></div>
            <div class="line-font-right" style="background-image: linear-gradient(90deg, rgb(255, 212, 80) 0%, transparent 100%);">
              <div style="position: absolute;color: white;font-size: 1vw;line-height: 1.5vw;font-family: test;letter-spacing: 1px;left: 0.5vw">申请加入</div>
            </div>
          </div>

          <div class="select" style="margin-left: auto">
            <el-select v-model="selectMessageStatus"
                       placeholder="请选择"
                       @change="getMessage">
              <el-option v-for="item in messageStatus"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="under-line"></div>
      </div>
      <div style="margin: 0vw auto 0;width: 95%;display: flex;flex-direction: column;align-items: center;justify-content: flex-end;height: 69vh">
        <el-table :data="messageTable"
                  border
                  style="overflow: auto;scrollbar-width: none;"
                  class="msg-table"
                  :cell-style="{fontSize:'0.5vw',whiteSpace:'nowrap',height:'4.5vh',padding:'0'}"
                  :header-cell-style="{background:'rgb(229,229,229)',color:'rgb(144, 147, 153)',fontWeight:'600',height:'4.5vh'}">
          <el-table-column label="序号" type="index" width="70" align="center"></el-table-column>
          <el-table-column label="标题" prop="title" :formatter="setTitle" align="center"></el-table-column>
          <el-table-column label="内容" prop="content"  :formatter="setContent" align="center"></el-table-column>
          <el-table-column prop="from" label="发送者" :formatter="setSender" align="center"></el-table-column>
          <el-table-column prop="to" label="接收者" :formatter="rewriteAll" align="center"></el-table-column>
          <el-table-column  label="操作" align="center">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)"
                         type="text"
                         size="small">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="page"
                       hide-on-single-page
                       layout="prev, pager, next"
                       :page-size="messagePage.limit"
                       @current-change="changePage"
                       :total="messagePage.total">
        </el-pagination>

        <el-dialog title="消息"
                   :visible="messageDialogVisible"
                   :before-close="handleClose"
                   width="30%"
                   center>
          <div class="dialog-table">
            <div class="table-title">
              <div style="line-height:2vw; height:100%;width: 50%;text-align: left;font-size: 0.7vw;border-right: 1px #a0a0a0 solid"><span style="font-family: test;font-size: 0.7vw;color: #5eb2f7">来自:</span>{{messageFrom}}</div>
              <div style="line-height:2vw; height:100%;width: 50%;text-align: left;font-size: 0.7vw;"><span style="font-family: test;font-size: 0.7vw;color: #5eb2f7">发给:</span>{{messageTo}}</div>
            </div>
            <div class="table-body">
              <div class="body-left">详情</div>
              <div class="body-right">{{ dialogContent }}</div>
            </div>
          </div>

          <span slot="footer"
                class="dialog-footer">
            <el-button type="primary"
                       @click="checkMessage('teacherInSchool')"
                       v-if="(selectMessage.content.type)==='teacher'&&(user_type==='管理员'||user_type==='学校管理员')&&(selectMessageStatus===1||selectMessageStatus===0)">同意加入</el-button>
            <el-button type="primary"
                       @click="checkMessage(selectMessage.title.target==='classroom'?'studentInClassroom':'studentInSchool')"
                       v-if="(selectMessage.content.type)==='student'&&(user_type==='学校管理员'||user_type==='老师')&&(selectMessageStatus===1||selectMessageStatus===0)">同意加入</el-button>
            <el-button type="primary"
                       @click="checkMessage('all')"
                       v-if="selectMessageStatus===0">{{selectMessage.title&&selectMessage.title.target==='join'?'确认':'稍后处理'}}</el-button>
            <el-button type="primary"
                       @click="checkMessage('drop')"
                       v-if="(selectMessage.content.type)!=='all'&&(user_type==='管理员'||user_type==='学校管理员'||user_type==='老师')&&(selectMessageStatus===1||selectMessageStatus===0)&&(selectMessage.title.action!=='refuse'&&selectMessage.title.action!=='pass')">拒绝加入</el-button>
          </span>
        </el-dialog>
      </div>
    </div>

  </div>
</template>

<script>
import NavHeader from '@/components/NavHeader'
import { getArea, getCity, getProvince, getSchool } from '@/api/user'
import tabTitle from '@/components/tabTitle'
import { alreadyRead, getUserMessage, sendApply } from '@/api/message'
import {
  addStudent,
  addStudentToClassroom,
  addTeacher,
  addTeacherToClassroom,
  deleteStudent,
  deleteTeacher, editStudentInfo, editTeacherMessage
} from '@/api/school'

export default {
  name: 'userMessage',
  components: {
    NavHeader,
    tabTitle
  },
  layout:'home',
  data () {
    return {
      activePage: '我的消息',
      messageFrom:'',
      messageTo:'',
      messageTable: [],
      messageDialogVisible: false,
      messageActionVisible: false,
      dialogContent: '',
      readMessageId: '',
      authType: 0,
      province: [],
      user_type: '',
      city: [],
      area: [],
      school: [],
      messagePage: {
        page: 1,
        total: 0,
        limit: 13
      },
      selectMessage: { content: { type: 'all' } },
      passText: '加入为老师',
      selectMessageStatus: 0,
      messageFromId: '',
      messageStatus: [
        { value: 0, label: '未读' },
        { value: 1, label: '已读' },
        { value: 2, label: '已处理' }
      ],
      form: {
        name: '',
        sex: '',
        type: '',
        school: '',
        to: '',
        area: '',
        province: '',
        city: ''
      },
    }
  },
  mounted () {
    this.user_type = localStorage.getItem('user_identity')
    this.getMessage()
  },
  methods: {
    changePage (page) {
      getUserMessage(page, this.messagePage.limit, this.selectMessageStatus).then(res => {
        if (res.status === 'ok') {

          for (let i = 0; i < res.data.length; i++) {

            try {
              res.data[i].title = JSON.parse(res.data[i].title)
              res.data[i].content = JSON.parse(res.data[i].content)
            }
            catch {

            }
          }
          this.messagePage.page = res.page.current_page
          this.messagePage.total = res.page.total
          this.messageTable = res.data
        }
        else {
          this.$message.error('网络错误，无法获取消息')
        }
      })
    },
    getMessage () {
      getUserMessage(this.messagePage.page, this.messagePage.limit, this.selectMessageStatus).then(res => {
        if (res.status === 'ok') {

          for (let i = 0; i < res.data.length; i++) {

            try {
              res.data[i].title = JSON.parse(res.data[i].title)
              res.data[i].content = JSON.parse(res.data[i].content)
            }
            catch {

            }
          }
          this.messagePage.page = res.page.current_page
          this.messagePage.total = res.page.total
          this.messageTable = res.data
        }
        else {
          this.$message.error('网络错误，无法获取消息')
        }
      })
    },
    handleClick (row) {
      //console.log(JSON.stringify(row.content.targetName))
      let content = ''
      let type=row.content.type==='student'?'学生':'老师'
      let action=row.title.action==='join'?'加入':row.title.action==='pass'?'通过':row.title.action==='refuse'?'拒绝':row.title.action
      let target=row.title.target==='school'?'学校':'班级'
      this.messageFrom='用户ID'+row.from
      this.messageTo=row.to==='*'?'全体用户':'用户ID'+localStorage.getItem('uid')
      let targetName=''
      try{
        targetName=JSON.parse(row.content.targetName).name
      }
      catch {
        targetName=''
      }
      content += type+row.content.name+ '，申请' + action + targetName
      this.dialogContent = content
      this.messageDialogVisible = true
      this.messageFromId = row.from
      this.readMessageId = row['message_route_id']
      this.selectMessage = row
    },
    checkMessage (action) {
      console.log(action)
      switch (action) {
        case 'teacherInSchool': {
          addTeacher({ user_id: this.selectMessage.from }).then(res => {
            if (res.status === 'ok') {
              alreadyRead({ message_route_id: this.selectMessage.message_route_id, status: 2 }).then(res => {
                if (res.status === 'ok') {
                  let teacherMessage={
                    user_id:this.selectMessage.from,
                    name:this.selectMessage.content.name,
                    number:this.selectMessage.content.number||'123'
                  }
                  editTeacherMessage(teacherMessage).then(editRes=>{
                    if(editRes.status==='ok'){
                      this.$message.success('加入成功')
                      let message = {
                        level: 3,
                        title: JSON.stringify({
                          action: 'pass',
                          target: 'join'
                        }),
                        content: JSON.stringify({
                          name: this.selectMessage.content.name,
                          type: this.selectMessage.content.type
                        }),
                        to: 'user',
                        filter: { id: this.selectMessage.from }
                      }
                      sendApply(message).then(res => {
                        if (res.status === 'ok') {
                          this.getMessage()
                        }
                      })
                    }
                  })
                }
                else {
                  deleteTeacher({ user_id: this.selectMessage.from }).then(res => {
                    this.$message.error('操作失败')
                  })
                }
              })
            }
            else {
              this.$message.error('操作失败')
            }
          })
          break
        }
        case 'studentInSchool': {
          addStudent({ user_id: this.selectMessage.from }).then(res => {
            if (res.status === 'ok') {
              alreadyRead({ message_route_id: this.selectMessage.message_route_id, status: 2 }).then(res => {
                if (res.status === 'ok') {
                  this.$message.success('加入成功')
                  let message = {
                    level: 3,
                    title: JSON.stringify({
                      action: 'pass',
                      target: 'join'
                    }),
                    content: JSON.stringify({
                      name: this.selectMessage.content.name,
                      type: this.selectMessage.content.type
                    }),
                    to: 'user',
                    filter: { id: this.selectMessage.from }
                  }
                  sendApply(message).then(res => {
                    if (res.status === 'ok') {
                      this.getMessage()
                    }
                  })
                }
                else {
                  deleteStudent({ user_id: this.selectMessage.from }).then(res => {
                    this.$message.error('操作失败')
                  })
                }
              })
            }
            else {
              this.$message.error('操作失败')
            }
          })
          break
        }
        case 'drop': {
          let message = {
            level: 3,
            title: JSON.stringify({
              action: 'refuse',
              target: 'join'
            }),
            content: JSON.stringify({
              name: this.selectMessage.content.name,
              type: this.selectMessage.content.type
            }),
            to: 'user',
            filter: { id: this.selectMessage.from }
          }
          alreadyRead({ message_route_id: this.selectMessage.message_route_id, status: 2 }).then(res => {
            if (res.status === 'ok') {
              sendApply(message).then(res => {
                if (res.status === 'ok') {
                  this.$message.success('操作成功')
                  this.getMessage()
                }
              })
            }
          })
          break
        }
        case 'all': {
          alreadyRead({ message_route_id: this.selectMessage.message_route_id, status: 1 }).then(res => {
            if (res.status === 'ok') {
              this.$message.success('操作成功')
              this.getMessage()
            }
          })
          break
        }
        case 'studentInClassroom': {
          addStudentToClassroom({ class_id: this.selectMessage.content.targetData.id||JSON.parse(this.selectMessage.content.targetData).id, user_id: this.selectMessage.from }).then(res => {
            if (res.status === 'ok') {
              alreadyRead({ message_route_id: this.selectMessage.message_route_id, status: 2 }).then(res => {
                if (res.status === 'ok') {
                  let studentMessage={
                    class_id:this.selectMessage.content.targetData.id||JSON.parse(this.selectMessage.content.targetData).id,
                    user_id:this.selectMessage.from,
                    name:this.selectMessage.content.name,
                    number:this.selectMessage.content.number
                  }
                  editStudentInfo(studentMessage).then(editRes=>{
                    if(editRes.status==='ok'){
                      let message = {
                        level: 3,
                        title: JSON.stringify({
                          action: 'pass',
                          target: 'join'
                        }),
                        content: JSON.stringify({
                          name: this.selectMessage.content.name,
                          type: 'student'
                        }),
                        to: 'user',
                        filter: { id: this.selectMessage.from }
                      }
                      sendApply(message).then(res => {
                        if (res.status === 'ok') {
                          this.$message.success('成功')
                          this.getMessage()
                        }
                      })
                    }
                  })

                }
              })
            }
            else {
              this.$message.error('错误')
            }
          })
          break
        }
        case 'teacherInClassroom': {
          // addTeacherToClassroom({ class_id: this.selectMessage.content.targetData.id, user_id: this.selectMessage.from }).then(res => {
          //   if (res.status === 'ok') {
          //     alreadyRead({ message_route_id: this.selectMessage.message_route_id, status: 2 }).then(res => {
          //       if (res.status === 'ok') {
          //         let message = {
          //           level: 3,
          //           title: JSON.stringify({
          //             action: 'pass',
          //             target: 'join'
          //           }),
          //           content: JSON.stringify({
          //             name: this.selectMessage.content.name,
          //             type: 'teacher'
          //           }),
          //           to: 'user',
          //           filter: { id: this.selectMessage.from }
          //         }
          //         sendApply(message).then(res => {
          //           if (res.status === 'ok') {
          //             this.$message.success('成功')
          //           }
          //         })
          //       }
          //     })
          //   }
          //   else {
          //     this.$message.error('错误')
          //   }
          // })
          break
        }
        default: { }
      }
      this.messageDialogVisible = false
    },
    setTitle (row, column) {
      let title = ''
      let action=''
      let target=''
      if(row.title.action==='join'){
        action='加入'
      }
      if(row.title.action==='pass'){
        action='通过'
      }
      if(row.title.action==='refuse'){
        action='拒绝'
      }
      if(row.title.target==='school'){
        target='学校'
      }
      if(row.title.target==='classroom'){
        target='班级'
      }
      if(row.title.target==='join'){
        target='申请'
      }
      title += action + target
      return title
    },
    rewriteAll(row,column){
      if(row.to==='*'){
        return '全体用户'
      }
      else {
        return '用户ID:'+localStorage.getItem('uid')
      }
    },
    setContent (row) {
      let content = ''
      let type=row.content.type==='student'?'学生':'老师'
      let action=row.title.action==='join'?'加入':row.title.action==='pass'?'通过':row.title.action==='refuse'?'拒绝':row.title.action
      let target=row.title.target==='school'?'学校':'班级'
      let targetName=''
      try{
        targetName=JSON.parse(row.content.targetName).name
      }
      catch {
        targetName=''
      }
      content += type+row.content.name+ '，申请' + action + targetName
      content = content.length > 20 ? content.slice(0, 20) + '...' : content

      return content
    },
    setSender(row){
      return '用户ID:'+row.from
    },
    handleClose () {
      this.messageDialogVisible = false
    },
  }
}
</script>

<style scoped>
.msg-table::-webkit-scrollbar{
  display: none;
}
.account-line{
  height: 3vw;
  width: 80%;
  margin: 2.5vw auto 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  white-space: nowrap;
}
.msg-table /deep/ .cell{
  white-space: nowrap;
}
.line-font{
  height: 2.5vw;
  width: 8vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  cursor: pointer;
}
.line-font-left{
  width: 3px;
  height: 1.5vw;
  background-color: rgb(58, 192, 141);
}
.line-font-right{
  width: 6vw;
  height: 1.5vw;
  margin-left: 0.3vw;
  /*background-image: linear-gradient(90deg, rgb(58, 192, 141) 0%, transparent 100%);*/
  position: relative;
}
.under-line{
  width: 100%;
  height: 1px;
  background-color: #a0a0a0;
}
.header {
  position: relative;
  width: 100vw;
  height: 5vw;
}
.message-back {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-image: url("http://data.xiyilab.com/web/main/static/home/p背景装饰.png");
  background-position: center 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment:fixed;
  -webkit-background-size: cover;/* 兼容Webkit内核浏览器如Chrome和Safari */
  -o-background-size: cover;/* 兼容Opera */
}

.back-img {
  position: absolute;
  z-index: -999;
  object-fit: cover;
  overflow: hidden;
}
.message-body {
  width: 55vw;
  height: 80vh;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.page {
  height: 4vh;
  margin-top: 1vh;
  min-height: 30px;
  width: 100%;
  display: flex;
  justify-content: center;
}
.select /deep/ .el-select,
/deep/ .el-input,
/deep/ .el-input__inner{
  height: 1.5vw;
}
.select /deep/ .el-select .el-input .el-select__caret{
  line-height: 1.5vw;
}
.el-table::before{

}
.dialog-table{
  height: 10vw;
  width: 100%;
  border: 1px #a0a0a0 solid;
  display: flex;
  flex-direction: column;
}
.table-title{
  height: 2vw;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px #a0a0a0 solid;
}
.table-body{
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;

}
.body-right{
  width: 80%;
  height: 7vw;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7vw;
  font-family: test;
  text-align: left;
  margin: auto;
}
.body-left{
  width: 10%;
  height: 8vw;
  border-right: 1px #a0a0a0 solid;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7vw;
  font-family: test;
  color: #5eb2f7;
}
</style>
